import PanelHeader from './PanelHeader'

export default PanelHeader
